import PropTypes from 'prop-types';
import { FormikDate } from '@febos-io/design';

import { InputProps } from "./types";
import { useTranslation } from "../../../hooks";

export function Item({
  name
}:InputProps) {
  const { t } = useTranslation();

  return (
    <>
      <FormikDate
        name={`${name}[0]`}
        label={t('From')}
        required
      />
      <FormikDate
        name={`${name}[1]`}
        label={t('to')}
        className="mt-2"
        required
        isTo={true}
      />
    </>
  );
}

Item.propTypes = {
  name: PropTypes.string
};

export default Item;
